<template>
    <button @click="openContent()" id="HelpButton" :class="{ 'HelpButton--inactive': contentComponentOpen }">
        <span>Need help</span>
        <img src="@/assets/img/ui/icon-help.svg">
    </button>
</template>
<script>
export default {
    methods: {
        openContent() {
            app.api.PageManager.openContentComponentFromID(2216); // need help content
        }
    },

}
</script>

<style lang="scss" scoped>
#HelpButton {
    position: absolute;
    right: 25px;
    bottom: 25px;
    padding: 0 10px 0 15px;

    height: 40px;
    border-radius: 20px;
    background: var(--main-color);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    span {
        color: #fff;
    }

    img {
        width: 24px;
    }
}

.HelpButton--inactive {
    opacity: 0.5;
    pointer-events: none !important;

    * {
        pointer-events: none !important;
    }
}
</style>